import { Injectable } from "@angular/core";
import { AuthService } from "./auth.service";

@Injectable({
  providedIn: "root",
})
export class PrivilegeService {
  projectPrivileges: any;
  privileges: any;
  userType: string;
  constructor(private authService: AuthService) {
    this.authService.isLoggedIn.subscribe((res) => {
      console.log("isloggedin==>", res);
      if (res == false) {
        this.projectPrivileges = {};
        this.privileges = [];
      }
      this.authService.$privilegesInit.subscribe((result) => {
        this.init()
      })
    });
  }
  init() {
    this.userType = this.authService.user?.securityrole[0];
    this.privileges = JSON.parse(localStorage.getItem("privileges"));
    this.projectPrivileges =
      JSON.parse(localStorage.getItem("projectprivileges") || "{}") || {};
  }
  userProjectAccess(role: string, projectId: string): boolean {

    let privileges;
    if (this.userType == "GLOBAL_ADMIN" || this.userType == "SYSTEM_ADMINISTRATOR" || this.userType == "ORGANIZATION_LEADERSHIP") {
      privileges = this.privileges || [];
    } else {
      privileges = this.projectPrivileges[projectId] || [];
    }
    if (privileges.length > 0) {
      return privileges.includes(role);
    } else {
      return false;
    }
  }
  userAccess(role: string) {
    // console.log(role,'==>');

    let privileges = this.privileges || [];
    if (privileges.length > 0) {
      // console.log(privileges.includes(role));

      return privileges.includes(role);
    } else {
      return false;
    }
  }
}
